module.exports = __webpack_public_path__ + "img/Fossil-Creek.17c107d8.jpeg";